/*
**  rui-record-detail-field.js
**
**  rui-record-detail-field component
*/
import { LitElement, html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
export class RuiRecordDetailField extends LitElement {
    static get is() {
        return 'rui-record-detail-field';
    }
    static get properties() {
        return {
            labelText: { type: String },
            orientation: { type: String },
            isHighlighted: { type: Object },
            isValueAtypical: { type: Object }
        };
    }
    constructor() {
        super();
        this.labelText = '';
        this.orientation = 'horizontal';
        this.isHighlighted = false;
        this.isValueAtypical = false;
        this._hasCustomLabel = false;
    }
    render() {
        const isHorizontal = this.orientation.toLowerCase() !== 'vertical';
        let labelText = this.labelText;
        if (this.labelText && !this.labelText.endsWith(':') && !this.labelText.endsWith('?')) {
            labelText += ':';
        }
        if (this.querySelector(`*[slot='custom-record-detail-label']`)) {
            this._hasCustomLabel = true;
        }
        const containerClasses = {
            ['rui-record-detail-field-container-horizontal']: isHorizontal,
            ['rui-record-detail-field-container-vertical']: !isHorizontal
        };
        const labelClasses = {
            ['rui-record-detail-field-label']: true,
            ['rui-record-detail-field-highlighted']: this.isHighlighted
        };
        const valueClasses = {
            ['rui-record-detail-field-value']: true,
            ['rui-record-detail-field-highlighted']: this.isHighlighted,
            ['rui-record-detail-field-value-atypical']: this.isValueAtypical
        };
        return html `
            <div class="${classMap(containerClasses)}">
                ${(!this._hasCustomLabel && this.labelText) ? html `
                    <dt class="${classMap(labelClasses)}">${labelText}</dt>
                    ` : html `
                    <dt class="${classMap(labelClasses)}"><slot name="custom-record-detail-label"></slot></dt>
                `}
                
                <dd class="${classMap(valueClasses)}">
                    <slot></slot>
                </dd>
            </div>
        `;
    }
    static get styles() {
        return css `
            :host {
                display: block;
                margin-top: 5px;
                -webkit-font-smoothing: antialiased;
            }
            
            :host([orientation="vertical"]) {
                margin-bottom: 11px;
            }
            
            .rui-record-detail-field-container-horizontal {
                display: flex;
                flex-direction: row;
            }
            
            .rui-record-detail-field-container-vertical {
                display: flex;
                flex-direction: column;
            }
            
            .rui-record-detail-field-label {
                color: var(--rui-text-regular, #09175b);
                font-family: var(--rui-font-family, "Noto Sans", Roboto, Arial, -apple-system, system-ui, sans-serif);
                font-size: var(--rui-font-size, 13px);
                font-weight: var(--rui-font-weight, 400);
                vertical-align: top;
                min-height: 20px;
                line-height: 130%;
                padding-right: 5px;
            }
            
            .rui-record-detail-field-value {
                color: var(--rui-text-bright, #203660);
                font-family: var(--rui-font-family, "Noto Sans", Roboto, Arial, -apple-system, system-ui, sans-serif);
                font-size: var(--rui-font-size, 13px);
                font-weight: 500;
                vertical-align: top;
                margin-left: 0;
                min-height: 20px;
                text-align: right;
                line-height: 130%;
                overflow: hidden;
            }
            
            .rui-record-detail-field-container-horizontal .rui-record-detail-field-value {
                margin-left: auto;
            }
            
            .rui-record-detail-field-container-vertical .rui-record-detail-field-value {
                text-align: left;
                margin-top: 2px;
            }
            
            .rui-record-detail-field-highlighted {
                background-color: var(--rui-text-highlight, #ffffcd);
            }
            
            .rui-record-detail-field-value-atypical {
                color: var(--rui-text-error, #e13329);
            }
       
            @media print {
                .rui-record-detail-field-label,
                .rui-record-detail-field-value {
                    color: #000000;
                }
            }
        `;
    }
}
customElements.get(RuiRecordDetailField.is) || customElements.define(RuiRecordDetailField.is, RuiRecordDetailField);
